<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="width"
		viewBox="0 0 26 26"
	>
		<g
			fill="none"
			fill-rule="evenodd"
			transform="translate(1 1)"
		>
			<circle
				cx="12"
				cy="12"
				r="12"
				fill="#FFD879"
				stroke="#E2C172"
			/>
			<circle
				cx="7.647"
				cy="8.877"
				r="2.108"
				fill="#3C5396"
			/>
			<circle
				cx="16.079"
				cy="8.877"
				r="2.108"
				fill="#3C5396"
			/>
			<path
				stroke="#3C5396"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1.5"
				d="M7.385 14.77s1.454 2.46 4.923 2.46c3.468 0 4.923-2.46 4.923-2.46"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: 26,
		},
		height: {
			type: [Number, String],
			default: 26,
		},
	},
};
</script>
